
export default () => {
  function setMaxMinHeight(selector) {
    const elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    // 一旦リセット（リサイズ時に必須）
    elements.forEach(el => {
      el.style.minHeight = '';
    });

    let maxHeight = 0;

    elements.forEach(el => {
      const height = el.getBoundingClientRect().height;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    elements.forEach(el => {
      el.style.minHeight = `${Math.ceil(maxHeight)}px`;
    });
  }

  function adjustSolutionHeights() {
    setMaxMinHeight('.se-solution__item-title');
    setMaxMinHeight('.se-solution__item-text');
    setMaxMinHeight('.js-height-1');
    setMaxMinHeight('.js-height-2');
  }

  // 初期表示
  window.addEventListener('load', adjustSolutionHeights);

  // リサイズ対応
  window.addEventListener('resize', () => {
    clearTimeout(window.__solutionResizeTimer);
    window.__solutionResizeTimer = setTimeout(adjustSolutionHeights, 100);
  });
}